const schedules = {
  edit: 'Edit',
  delete: 'Delete',
  add_schedule: 'New Schedule',
  edit_schedule: 'Schedule',
  search_schedules: 'Search Schedules',
  search_schedule: 'Search schedule',
  save: 'Save',
  update: 'Update',
  cycle_length: 'Cycle Length ({{days}} days)',
  days_label: 'Days of week',
  dow: {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
  },
  schedule_name_placeholder: 'Schedule Name',
  cycle_date: 'Cycle Start Date',
  default_start_time: 'Default Start Time',
  default_end_time: 'Default End Time',
  date: 'Date',
  startTime: 'Start Time',
  endTime: 'End Time',
  custom: 'Custom',
  cycle_length_text: 'Cycle Length',
  cycle_1_week: '1 Week',
  cycle_2_weeks: '2 Weeks',
  cycle_3_weeks: '3 Weeks',
  cycle_4_weeks: '4 Weeks',
  cycle_1_day: '1 Day',
  cycle_2_days: '2 Days',
  cycle_3_days: '3 Days',
  cycle_4_days: '4 Days',
  cycle_5_days: '5 Days',
  cycle_6_days: '6 Days',
  custom_modal_msg: 'Select the amount of days in the cycle (max 28)',
  confirmation_msg:
    'Are you sure you want to change cycle length? Current configuration will be lost',
  date_confirmation_msg:
    'Are you sure you want to change the cycle start date? Current configuration will be lost',
  edit_event: 'Edit Event',
  holidays: {
    include: 'Include',
    exclude: 'Exclude',
    drag_and_drop: 'Drag and Drop a holiday to include or exclude',
    holidays: 'Holidays',
    add_new: 'Add New',
    include_description:
      'The duration of the holiday will be ADDED to the schedule',
    exlude_description:
      'The duration of the holiday will be REMOVED from the schedule',
  },
  table: {
    schedule_id: 'ID',
    schedule_label: 'SCHEDULES',
    cycle_length_label: 'CYCLE LENGTH',
    startdate_label: 'START DATE',
    active_label: 'STATE',
  },
  error: {
    hour_format: 'Format must be hh:mm AM/PM',
    start_time: 'Start time cannot be after end time',
    end_time: 'End time cannot be before start time',
  },
  delete_schedule_confirm: 'Are you sure you want to delete {{name}} schedule?',
  no_content: 'No Content',
  created_successfully: 'Schedule created successfully',
  updated_successfully: 'Schedule updated successfully',
  deleted_successfully: 'Schedule deleted successfully',
  error_updating: 'Error updating schedule',
};

export default schedules;
